import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';

const CartIcon = ({ count = 0, total = 0, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        onClick={onClick}
        className="relative p-2 hover:bg-muted rounded-full transition-colors"
        aria-label="Carrito de compras"
      >
        <ShoppingCart className="w-5 h-5" />
        {count > 0 && (
          <motion.span
            key={count}
            initial={{ scale: 0 }}
            animate={{ 
              scale: [0, 1.3, 1],
              rotate: [0, 10, -10, 0],
              transition: { duration: 0.4 }
            }}
            className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium"
          >
            {count}
          </motion.span>
        )}
      </button>

      {/* Mini preview al hover */}
      {isHovered && count > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          className="absolute top-full right-0 mt-2 bg-background border border-border rounded-lg shadow-xl p-4 w-64 z-50"
        >
          <p className="text-sm text-muted-foreground mb-2">
            {count} {count === 1 ? 'producto' : 'productos'} en el carrito
          </p>
          <p className="text-lg font-bold text-primary">
            Total: €{total.toFixed(2)}
          </p>
          <button
            onClick={onClick}
            className="w-full mt-3 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary-hover transition-colors text-sm font-medium"
          >
            Ver carrito
          </button>
        </motion.div>
      )}
    </div>
  );
};

export default CartIcon;